export const TYPES = {
  SET_TOTAL_TASK: "task_effort/SET_TOTAL_TASK",
  SET_UNFINISHED_TASK_COUNT: "task_effort/SET_UNFINISHED_TASK_COUNT",
};
